<template>
  <v-menu ref="menu" v-model="menu" transition="scale-transition" offset-y min-width="290px" :close-on-content-click="false" bottom eager>
    <template v-slot:activator="{ on, attrs }">
      <mf-button icon="mood" color="cinza-0" type="icon" size="sm" class="mt-0" @click="menu = true" />
    </template>
    <picker :data="emojiIndex" :i18n="i18n" native title="Emojis" emoji="shopping_trolley" emoji-tooltip @select="selectEmoji" />
  </v-menu>
</template>

<script>
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import data from 'emoji-mart-vue-fast/data/twitter.json'

const EXCLUDED_EMOJIS = [
  'smiling_face_with_tear',
  'disguised_face',
  'pinched_fingers',
  'anatomical_heart',
  'lungs',
  'red_haired_person',
  'curly_haired_person',
  'white_haired_person',
  'bald_person',
  'health_worker',
  'student',
  'judge',
  'teacher',
  'farmer',
  'cook',
  'factory_worker',
  'mechanic',
  'office_worker',
  'scientist',
  'technologist',
  'singer',
  'pilot',
  'artist',
  'astronaut',
  'firefighter',
  'ninja',
  'man_in_tuxedo',
  'woman_in_tuxedo',
  'man_with_veil',
  'woman_with_veil',
  'woman_feeding_baby',
  'man_feeding_baby',
  'person_feeding_baby',
  'mx_claus',
  'person_with_probing_cane',
  'person_in_manual_wheelchair',
  'person_in_motorized_wheelchair',
  'people_hugging',
  'black_cat',
  'bison',
  'mammoth',
  'beaver',
  'dodo',
  'feather',
  'seal',
  'beetle',
  'cockroach',
  'worm',
  'fly',
  'potted_plant',
  'blueberries',
  'olive',
  'bell_pepper',
  'flatbread',
  'tamale',
  'fondue',
  'teapot',
  'bubble_tea',
  'magic_wand',
  'pinata',
  'nesting_dolls',
  'sewing_needle',
  'knot',
  'rock',
  'wood',
  'hut',
  'pickup_truck',
  'roller_skate',
  'thong_sandal',
  'military_helmet',
  'accordion',
  'long_drum',
  'coin',
  'boomerang',
  'carpentry_saw',
  'screwdriver',
  'hook',
  'ladder',
  'elevator',
  'mirror',
  'window',
  'plunger',
  'mouse_trap',
  'bucket',
  'toothbrush',
  'headstone',
  'placard',
]
const EXLCUDED_CATEGORIES = ['flags']

const emojisToShowFilter = (emoji) => {
  return !EXCLUDED_EMOJIS.includes(emoji.short_names[0])
}

let emojiIndex = new EmojiIndex(data, {
  exclude: EXLCUDED_CATEGORIES,
  emojisToShowFilter,
})

export default {
  name: 'EmojiPicker',
  components: {
    Picker,
  },
  data: () => ({
    menu: false,
    emojiIndex: emojiIndex,
  }),
  computed: {
    i18n() {
      return {
        search: 'Buscar',
        notfound: 'Nenhum Emoji Encontrado',
        categories: {
          search: 'Resultados da Busca',
          recent: 'Usados Frequentemente',
          people: 'Smileys & Pessoas',
          nature: 'Animais & Natureza',
          foods: 'Comidas & Bebidas',
          activity: 'Atividades',
          places: 'Viagens & Lugares',
          objects: 'Objetos',
          symbols: 'Simbolos',
          flags: 'Bandeiras',
          custom: 'Customizados',
        },
      }
    },
  },
  methods: {
    selectEmoji(emoji) {
      this.$emit('select', emoji.native)
    },
  },
}
</script>
